import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content-with-ai-btn" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["data-index", "onDragstart"]
const _hoisted_4 = { class: "media-thumb-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "media-actions-overlay" }
const _hoisted_7 = { class: "add-image-placeholder" }
const _hoisted_8 = {
  key: 0,
  class: "upload-progress-container"
}
const _hoisted_9 = { class: "progress-label" }
const _hoisted_10 = {
  key: 0,
  class: "video-preview-container"
}
const _hoisted_11 = { class: "video-item" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "media-actions" }
const _hoisted_14 = {
  key: 2,
  class: "upload-progress-container"
}
const _hoisted_15 = { class: "upload-progress-item" }
const _hoisted_16 = { class: "progress-label" }
const _hoisted_17 = { class: "dialog-footer" }
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = { class: "polish-comparison-container" }
const _hoisted_20 = { class: "comparison-panel" }
const _hoisted_21 = { class: "content-panel original-content" }
const _hoisted_22 = { class: "comparison-panel" }
const _hoisted_23 = { class: "content-panel polished-content" }
const _hoisted_24 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "dialog-footer comparison-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: _ctx.title || '编辑帖子',
    width: "600px",
    "close-on-click-modal": false,
    onClose: _ctx.closeDialog
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_17, [
        _createVNode(_component_el_button, { onClick: _ctx.closeDialog }, {
          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.submitEdit,
          loading: _ctx.submitting
        }, {
          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
            _createTextVNode("确定", -1)
          ]))]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, { "label-width": "80px" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "帖子标题" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.editForm.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editForm.title) = $event)),
                type: "textarea",
                rows: 1,
                placeholder: "请输入帖子标题",
                maxlength: "100",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "帖子内容" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.editForm.content,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editForm.content) = $event)),
                  type: "textarea",
                  rows: 6,
                  placeholder: "请输入帖子内容",
                  maxlength: "10000",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", {
                  class: "ai-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPolishInstructionDialog = true))
                }, "AI")
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "封面图片" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "cover-uploader",
                "auto-upload": false,
                "show-file-list": false,
                "on-change": _ctx.handleCoverChange,
                "list-type": "picture-card"
              }, {
                default: _withCtx(() => [
                  (_ctx.editForm.coverImage)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.editForm.coverImage,
                        class: "cover-image"
                      }, null, 8, _hoisted_2))
                    : (_openBlock(), _createBlock(_component_el_icon, {
                        key: 1,
                        class: "cover-uploader-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["on-change"]),
              (_ctx.editForm.coverImage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "delete-cover-btn",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removeCoverImage && _ctx.removeCoverImage(...args)))
                  }, " X "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "九宫格图片" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "media-grid",
                onDragover: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
                onDragenter: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageMediaList, (media, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "media-item image-item",
                    "data-index": index,
                    draggable: "true",
                    onDragstart: ($event: any) => (_ctx.onImageDragStart($event, index)),
                    onDragend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onImageDragEnd && _ctx.onImageDragEnd(...args))),
                    onDragover: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onImageDragOver && _ctx.onImageDragOver(...args))),
                    onDragenter: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onImageDragEnter && _ctx.onImageDragEnter(...args))),
                    onDragleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onImageDragLeave && _ctx.onImageDragLeave(...args))),
                    onDrop: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onImageDrop && _ctx.onImageDrop(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: media.url,
                        class: "media-thumb"
                      }, null, 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_icon, {
                          class: "action-icon delete-icon",
                          onClick: _withModifiers(($event: any) => (_ctx.removeMediaByType('image', index)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Close)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ], 40, _hoisted_3))
                }), 128)),
                (_ctx.imageMediaList.length < 9)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "media-item empty-grid",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.triggerAddImage && _ctx.triggerAddImage(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_el_icon, { class: "add-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Plus)
                          ]),
                          _: 1
                        }),
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "add-text" }, "添加图片", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 32),
              (_ctx.imageUploadProgress.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageUploadProgress, (progressItem, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'img-progress-' + progressItem.id,
                        class: "upload-progress-item"
                      }, [
                        _createElementVNode("div", _hoisted_9, "图片" + _toDisplayString(index + 1) + "上传中... " + _toDisplayString(progressItem.progress) + "%", 1),
                        _createVNode(_component_el_progress, {
                          percentage: progressItem.progress,
                          "show-text": false
                        }, null, 8, ["percentage"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "el-upload__tip" }, "上传九宫格图片，最多9张，支持拖拽排序", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "上传视频" }, {
            default: _withCtx(() => [
              (_ctx.videoMediaList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("video", {
                        src: _ctx.videoMediaList[0].url,
                        controls: "",
                        class: "video-element"
                      }, null, 8, _hoisted_12),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "small",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.removeMediaByType('video', 0)))
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createTextVNode("删除视频", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock(_component_el_upload, {
                    key: 1,
                    class: "video-uploader",
                    "auto-upload": false,
                    "show-file-list": false,
                    "on-change": _ctx.handleVideoChange,
                    accept: "video/*",
                    limit: 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createTextVNode("上传视频", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["on-change"])),
              (_ctx.videoUploadProgress > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, "视频上传中... " + _toDisplayString(_ctx.videoUploadProgress) + "%", 1),
                      _createVNode(_component_el_progress, {
                        percentage: _ctx.videoUploadProgress,
                        "show-text": false
                      }, null, 8, ["percentage"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "el-upload__tip" }, "只能上传一个视频文件", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showPolishInstructionDialog,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showPolishInstructionDialog) = $event)),
        title: "AI润色指令",
        width: "400px",
        center: "",
        class: "ai-polish-instruction-dialog"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_18, [
            _createVNode(_component_el_button, {
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showPolishInstructionDialog = false)),
              class: "cancel-btn"
            }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createTextVNode("取消", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.startPolishContent,
              loading: _ctx.isPolishing,
              class: "confirm-btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isPolishing ? '润色中...' : '开始润色'), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.polishInstruction,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.polishInstruction) = $event)),
            type: "textarea",
            rows: 4,
            placeholder: "请输入润色指令，例如：让语言更生动有趣、调整为教程风格等",
            maxlength: "200",
            "show-word-limit": "",
            class: "custom-textarea"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showPolishResultDialog,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showPolishResultDialog) = $event)),
        title: "AI润色结果对比",
        width: "80%",
        top: "5vh",
        class: "polish-result-dialog"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_el_button, {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showPolishResultDialog = false)),
              class: "cancel-btn"
            }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                _createTextVNode("不接受", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.acceptPolishedContent,
              disabled: _ctx.isPolishing || !_ctx.polishedContent,
              class: "confirm-btn"
            }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                _createTextVNode(" 接受润色结果 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[27] || (_cache[27] = _createElementVNode("h3", null, "原始内容", -1)),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("pre", null, _toDisplayString(_ctx.editForm.content), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[29] || (_cache[29] = _createElementVNode("h3", null, "AI润色内容", -1)),
              _createElementVNode("div", _hoisted_23, [
                (_ctx.isPolishing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_el_icon, {
                        class: _normalizeClass(['is-loading'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Loading)
                        ]),
                        _: 1
                      }),
                      _cache[28] || (_cache[28] = _createElementVNode("span", null, "AI正在润色中...", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "markdown-content",
                  innerHTML: _ctx.renderedPolishedContent
                }, null, 8, _hoisted_25)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onClose"]))
}